import { render, staticRenderFns } from "./EcommerceProductBrandList.vue?vue&type=template&id=494feb3d&scoped=true&lang=pug&"
import script from "./EcommerceProductBrandList.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductBrandList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EcommerceProductBrandList.vue?vue&type=style&index=0&id=494feb3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494feb3d",
  null
  
)

export default component.exports